<template>
  <div id="member-news" class="module">
    <el-row class="flexbox flexbox__v-center">
      <el-col :span="18">
        <h1>{{ $attrs.heading }}</h1>
        <h4>{{ $attrs.blockquote }}</h4>
      </el-col>

      <el-col :span="6" class="text-right">
        <el-button type="primary" @click="open">Read more</el-button>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "MemberNews",
  data() {
    return {
      paragraph:
        "Lorem ipsum dolor sit amet, cu utinam argumentum mel. Sed causae nostrud hendrerit ei. Erat labore vituperatoribus at pri, vidit facer scriptorem per cu. Id simul oporteat sit. Duo an purto dolorum mandamus, exerci graeco ea has, mea numquam moderatius eu.</p><p>At copiosae constituam eum, solum necessitatibus ea nec. Sed at veri ubique, utroque accommodare complectitur vel ne, at vel sumo accusamus consetetur. Eos veniam gloriatur eu. An vel erant ceteros, mei eu falli integre. Vis ipsum docendi albucius an, eos ubique dolores suavitate no. Summo officiis ad eos."
    };
  },
  computed: {
    modalText: function() {
      return (
        "<h4>" +
        this.$attrs.blockquote +
        "</h4>" +
        "<p>" +
        this.paragraph +
        "</p>"
      );
    }
  },
  methods: {
    open() {
      this.$alert(this.modalText, this.$attrs.heading, {
        closeOnClickModal: true,
        dangerouslyUseHTMLString: true,
        confirmButtonText: "Link"
        /*callback: action => {
                        this.$message({
                            type: "info",
                            message: `action: ${action}`
                        });
                    } */
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.module {
  padding: 2rem;
  background: #00b6d3;
  box-shadow: 0 2px 16px 0 rgba(190, 190, 190, 0.52);
  border-radius: 5px;
}

h1 {
  color: #ffffff;
}

h4 {
  font-family: Lato-SemiboldItalic;
  font-size: 16px;
  color: #ffffff;
  letter-spacing: 1px;
  line-height: 20px;
}
</style>
